// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1J2yP","list":"PatternAutocomplete_list__3x9Tq"};